<template>
    <div>
        <div class="taxi-order-form">
            <TaxiBill></TaxiBill>
        </div>
        <div class="order-info">
            <van-form @submit="onSubmit">
                <van-field name="stepper" label="乘车人数">
                    <template #input>
                        <van-stepper v-model="stepper" />
                    </template>
                </van-field>
                <van-field
                        v-model="username"
                        name="username"
                        label="联系人："
                        placeholder=""
                        :rules="[{ required: true, message: '请填写真实姓名' }]"
                />
                <van-field
                        v-model="weixin"
                        name="weixin"
                        label="微信号："
                        placeholder=""
                        :rules="[{ required: true, message: '请填写微信号' }]"
                />
                <van-field
                        v-model="phone"
                        name="phone"
                        label="联系电话："
                        placeholder=""
                        :rules="[{ required: true, message: '请填写联系电话' }]"
                />
                <van-field
                        v-model="email"
                        name="email"
                        label="邮箱地址："
                        placeholder=""
                        :rules="[{ required: true, message: '请填写邮箱地址' }]"
                />
                <van-field
                        v-model="message"
                        rows="1"
                        name="message"
                        autosize
                        label="备注："
                        type="textarea"
                        placeholder="请添加您的备注信息"
                />
                <div style="margin: 16px;">
                    <van-button round block type="info" native-type="submit">
                        确认下单
                    </van-button>
                </div>
            </van-form>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import { Stepper } from 'vant';
    Vue.use(Stepper);
    import TaxiBill from "../components/TaxiBill";
    export default {
        data() {
            return {
                stepper: 1,
                username:'',
                email:'',
                phone:'',
                weixin:'',
                message:''
            };
        },
        created:function () {
            alert()
        },
        methods:{
            onSubmit(values){
                console.log(values);
                this.$router.push('/taxi-order-info')
            }
        },
        components: {TaxiBill}
    }
</script>
<style>
    .van-stepper__minus,.van-stepper__plus{
        border-radius: 15px;
    }
    .order-info{
        padding: 10px;background-color: #fff;
    }
</style>